module.exports = __webpack_public_path__ + "img/hvac-mechanical-maintenance-05.8513e08a.jpg";